import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const normalizeLanguage = (value) => {
  const v = (value || '').toString().toLowerCase()
  if (v.startsWith('français')) return 'français'
  return 'english'
}

const initialLanguage =
  typeof window !== 'undefined' && window.localStorage
    ? normalizeLanguage(window.localStorage.getItem('language') || window.localStorage.getItem('lang') || 'english')
    : 'english'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
english:{
  translation: {
    howToPlay: 'HOW TO PLAY',
    howToPlayDescription: 'Swipe to kick the ball and aim for the goal before time runs out.',
    start: 'Start',
    dataEntry: 'ENTER YOUR INITIALS FOR THE LEADERBOARD',
    submit: 'Submit',
    thankYou: 'YOUR SCORE IS',
    thankYouDescription: 'Nice shot!',
    thankYouDescription2: 'Share your score on <br /> social and tag <br /> @TorontoPearson so we <br /> can cheer you on.',
    next: 'Next',
    leaderboard: 'LEADERBOARD',
    end: 'Close',
  },
},
français:{
  translation: {
    howToPlay: 'Comment jouer',
    howToPlayDescription: 'Visez le but et faites glisser votre doigt pour frapper le ballon avant que le temps soit écoulé.',
    start: 'Commencer',
    dataEntry: 'ENTREZ VOS INITIALES POUR LE TABLEAU DE CLASSEMENT',
    submit: 'Soumettre',
    thankYou: 'VOTRE POINTAGE EST',
    thankYouDescription: 'Beau tir!',
    thankYouDescription2: 'Partagez votre résultat sur les médias sociaux et mentionnez @TorontoPearson pour que nous puissions vous encourager.',
    next: 'Suivant',
    leaderboard: 'CLASSEMENT',
    end: 'Fermer',
  },
},
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: initialLanguage, //language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: 'english',
    //you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    //if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
